import React, { ReactElement, useMemo } from 'react';

import qs from 'query-string';
import { FormattedMessage } from 'react-intl';
import makeStyles from '@mui/styles/makeStyles';
import {
  Card,
  CardContent,
  CardMedia,
  Divider,
  Typography
} from '@mui/material';
import { ReactComponent as CollectorErrorIcon } from './icons/Collector_Error_Icon.svg';
import { ReactComponent as ZTTextLogo } from './icons/ZeroTime_TextLogo.svg';

const useStyles = makeStyles((theme) => ({
  errorLogo: {
    display: 'flex',
    justifyContent: 'center'
  },
  ztLogo: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  card: {
    width: theme.spacing(53),
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    marginTop: theme.spacing(2)
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    flexDirection: 'column',
    height: '100vh',
    background: '#f5f5f5'
  },
  message: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(4)
  },
  divider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  }
}));

const CollectorErrorPage = (): ReactElement => {
  const classes = useStyles();
  const { collectorName, ecid, errorMsg, category } = qs.parse(
    location.search || ''
  ) as {
    collectorName: string;
    ecid: string;
    errorMsg: string;
    category: string;
  };

  const errorMessage = useMemo(() => {
    if (category === 'install')
      return (
        <>
          <span> {collectorName} </span>
          <FormattedMessage id="collectorError.installMessage" />
        </>
      );
    else if (category === 'uninstall')
      return (
        <>
          <span> {collectorName} </span>
          <FormattedMessage id="collectorError.uninstallMessage" />
        </>
      );
  }, [category, collectorName]);

  const errorInfoMessage = useMemo(() => {
    if (category === 'install')
      return <FormattedMessage id="collectorError.errorInstallMessage" />;
    else if (category === 'uninstall')
      return <FormattedMessage id="collectorError.errorUninstallMessage" />;
    return <FormattedMessage id="collectorError.errorMessage1" />;
  }, [category]);

  return (
    <div data-testid="collector-error-page" className={classes.container}>
      <div className={classes.ztLogo} data-testid="collector-error-ztLogo">
        <ZTTextLogo />
      </div>
      <br />
      <Card className={classes.card} data-testid="collector-error-card">
        <CardMedia
          className={classes.errorLogo}
          data-testid="collector-error-logo"
        >
          <CollectorErrorIcon />
        </CardMedia>
        <CardContent className={classes.message}>
          <Typography data-testid="error-info-message" variant="h4">
            {errorInfoMessage}
          </Typography>
          <br />
          <Typography data-testid="collector-error-message" variant="body1">
            {errorMessage}
          </Typography>
          <Typography data-testid="collector-error-message" variant="body1">
            {errorMsg}
          </Typography>
          <br />
          <Typography variant="body1">
            {<FormattedMessage id="collectorError.closeWindowMessage" />}
          </Typography>
          <br />
          {ecid && (
            <Divider data-testid="collector-error-nerd-stuff-divider-1" />
          )}

          {ecid && (
            <Typography variant="body2" noWrap className={classes.divider}>
              {
                <span>
                  <FormattedMessage id="collectorError.nerdStuff" />
                </span>
              }
              &nbsp;
              {ecid}
            </Typography>
          )}

          {ecid && (
            <Divider data-testid="collector-error-nerd-stuff-divider-2" />
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default CollectorErrorPage;
